import React from 'react';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { MobileStickyBar } from '../components/layout/MobileStickyBar';
import { Footer } from '../components/layout/Footer';
import { CategoryHero } from '../components/category/CategoryHero';
import { BuyingGuidance } from '../components/category/BuyingGuidance';
import { ProductList } from '../components/category/ProductList';
import { HelpModuleAndFAQ } from '../components/category/HelpModuleAndFAQ';
export function CommercialCategory() {
  return <div className="min-h-screen flex flex-col" data-id="element-578">
      <TopBar data-id="element-579" />
      <Header data-id="element-580" />
      <Navigation data-id="element-581" />

      <main className="flex-grow" data-id="element-582">
        <CategoryHero data-id="element-583" />
        <BuyingGuidance data-id="element-584" />
        <ProductList data-id="element-585" />
        <HelpModuleAndFAQ data-id="element-586" />
      </main>

      <Footer data-id="element-587" />
      <MobileStickyBar data-id="element-588" />
    </div>;
}